"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageContainer = exports.Checkbox = exports.CheckboxPaymentContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const utils_1 = require("../../utils");
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
exports.CheckboxPaymentContainer = styled_components_1.default.div `
  display: flex;
  align-items: ${({ deviceType }) => ((0, utils_1.isMobile)(deviceType) ? 'center' : 'flex-start')};
  gap: 10px;
  border: 1px solid ${({ error }) => (error ? monera_app_core_1.Red_500 : 'transparent')};
  border-radius: 4px;
  padding: 8px;
`;
exports.Checkbox = styled_components_1.default.input.attrs({ type: 'checkbox' }) `
  appearance: ${({ error }) => (error ? 'none' : 'auto')};
  border: 1px solid ${({ error }) => (error ? monera_app_core_1.Red_500 : 'transparent')};
  border-radius: 2px;
  width: 13px;
  height: 13px;
  scale: 1.5;
  margin-top: ${({ deviceType }) => ((0, utils_1.isMobile)(deviceType) ? '0' : '21px')};
  cursor: pointer;
  flex-shrink: 0;
`;
exports.ErrorMessageContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 10px;
`;
